module.exports = __webpack_public_path__ + "static/media/icon-3.524d40e4.svg";